import { useEffect, useRef, useState } from "react";

import { Card } from "./Card";
import { cn } from "@verse_core/shared_components/ClassName";

export const CardSection = () => {
  const cards = [
    {
      src: "/landing_page_assets/rive/17.riv",
      fallbackSrc: "/landing_page_assets/payor_case_management_page/card1.png",
      title: "Real-time coverage validation",
      description:
        "See in real-time whether a DME order meets coverage criteria, specific to your plan.",
    },
    {
      src: "/landing_page_assets/rive/18.riv",
      fallbackSrc: "/landing_page_assets/payor_case_management_page/card2.png",
      title: "Transparency and clarity",
      description:
        "Track the delivery timeline for every order, triage issues - all without making a phone call.",
    },
    {
      src: "/landing_page_assets/rive/19.riv",
      fallbackSrc: "/landing_page_assets/payor_case_management_page/card3.png",
      title: "Make members self-sufficient",
      description:
        "Members receive real-time delivery updates and can initiate their own resupply requests.",
    },
  ];

  const scrollRef = useRef<HTMLDivElement>(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const scrollContainer = scrollRef.current;

    const onScroll = () => {
      if (!scrollContainer) return;
      const scrollLeft = scrollContainer.scrollLeft;
      const cardWidth = scrollContainer.offsetWidth + 32; // 32px gap
      const index = Math.round(scrollLeft / cardWidth);
      setCurrentIndex(index);
    };

    scrollContainer?.addEventListener("scroll", onScroll, { passive: true });
    return () => scrollContainer?.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="tw-z-20">
      <div
        ref={scrollRef}
        className={
          "tw-z-20 tw-flex tw-snap-x tw-snap-mandatory tw-items-start tw-gap-x-[1.5em] tw-overflow-hidden tw-overflow-x-auto tw-rounded-[2em] tw-px-[1.5em] tw-py-[.5em] min440:tw-mx-0 min440:tw-px-0"
        }
        style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
      >
        {cards.map((card, index) => (
          <Card key={`card-${index}`} {...card} />
        ))}
      </div>

      {/* Carousel indicators for mobile*/}
      <div className="tw-mt-[1em] tw-flex tw-justify-center tw-gap-[.5em] min440:tw-hidden">
        {cards.map((_, idx) => (
          <div
            key={idx}
            className={cn(
              "tw-h-[.5em] tw-w-[.5em] tw-rounded-full tw-bg-black tw-transition-opacity tw-duration-300",
              currentIndex !== idx && "tw-opacity-20",
            )}
          />
        ))}
      </div>
    </div>
  );
};
